import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ fontWeights, palette }: Theme) => ({
  title: {
    margin: 0,
    fontWeight: fontWeights.medium,
    fontSize: '1rem',
    lineHeight: 1.2,
  },
  text: {
    margin: 0,
    padding: '0.5rem',
    backgroundColor: palette.grey[200],
    color: palette.grey[700],
    borderBottom: `2px solid ${palette.grey[400]}`,
  },
  asterisk: {
    position: 'relative',
    top: 2,
    right: 0,
    color: palette.error.main,
    fontSize: '1.5rem',
  },
  disclaimer: {
    margin: '0.5rem 0 0',
    color: palette.error.dark,
  },
}));
